var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.82 10.1734L11.1267 9.98005C10.9276 9.95666 10.7258 9.97871 10.5364 10.0445C10.347 10.1103 10.175 10.2182 10.0334 10.36L8.80669 11.5867C6.91429 10.624 5.37607 9.08579 4.41336 7.19338L5.64669 5.96005C5.93336 5.67338 6.07336 5.27338 6.02669 4.86672L5.83336 3.18672C5.7957 2.86144 5.63967 2.5614 5.395 2.34378C5.15033 2.12616 4.83414 2.00618 4.50669 2.00672H3.35336C2.60003 2.00672 1.97336 2.63338 2.02003 3.38672C2.37336 9.08005 6.92669 13.6267 12.6134 13.98C13.3667 14.0267 13.9934 13.4 13.9934 12.6467V11.4934C14 10.82 13.4934 10.2534 12.82 10.1734Z",
    fill: "#4F5662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhone);
export default __webpack_public_path__ + "static/media/ic-phone.20f54f8091751467172309191cb64901.svg";
export { ForwardRef as ReactComponent };